export default function SafetySection() {
  const tips = [
    'Verify product sources before purchasing',
    'Review seller information and ratings',
    'Check QC photos carefully',
    'Understand shipping costs upfront',
    'Protect personal payment information',
  ];

  return (
    <section className="py-24 md:py-32 bg-background-100">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-14 lg:gap-20 items-center">
          <div className="lg:w-1/2">
            <img
              src="https://readdy.ai/api/search-image?query=A%20closeup%20of%20a%20modern%20computer%20screen%20displaying%20a%20secure%20shopping%20interface%20with%20a%20prominent%20green%20verified%20badge%20and%20lock%20icon%20soft%20natural%20lighting%20from%20a%20nearby%20window%20potted%20succulent%20plant%20on%20the%20desk%20warm%20wooden%20desk%20surface%20calm%20trustworthy%20atmosphere%20editorial%20photography&width=800&height=600&seq=safety-trust-v2&orientation=landscape"
              alt="Superbuy Spreadsheet Safety - Trust and security illustration showing secure shopping interface"
              title="Superbuy Spreadsheet Safety Guide"
              className="w-full h-auto rounded-2xl"
            />
          </div>
          <div className="lg:w-1/2">
            <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 mb-6">
              Is Superbuy Spreadsheet Safe?
            </h2>
            <p className="text-foreground-600 text-base leading-relaxed mb-8">
              Safety is the most important part of online shopping research. Our Superbuy Spreadsheet resources are designed for educational and informational purposes. We encourage every user to follow these safety practices:
            </p>
            <ul className="space-y-3 mb-8">
              {tips.map((tip) => (
                <li key={tip} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-accent-600 text-sm"></i>
                  </div>
                  <span className="text-foreground-700 text-sm">{tip}</span>
                </li>
              ))}
            </ul>
            <p className="text-foreground-400 text-xs leading-relaxed border-l-2 border-secondary-400 pl-4 italic">
              Disclaimer: SuperbuySpread.lat provides educational resources and shopping information. We do not directly operate third-party sellers and users should complete independent verification before purchasing.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}